<template>
    <div>
        <h6 style="font-weight: bold">{{ title }}</h6>

        <b-table :items="commodities" :fields="fields" fixed outlined></b-table>
    </div>
</template>
<script>
  import localization from '@/mixins/localizationMixin';
  export default {
      components: {},

      mixins: [localization],

      props: {
          commodities: { type: Array, required: true },
          title: { type: String, required: true },
      },

      data() {
          return {
              fields: [
                  { key: 'description', sortable: false },
                  {
                      key: 'countryOfManufacture',
                      sortable: false,
                      label: this.$t('history.label.OriginCountry'),
                  },
                  {
                      key: 'harmonizedCode',
                      sortable: false,
                      label: this.$t('history.label.ScheduleBNumber'),
                  },
                  {
                      key: 'unitWeight',
                      sortable: false,
                      formatter: (value) => this.localizedNumber(value),
                      label: this.$t('history.label.Weight'),
                  },
                  {
                      key: 'quantity',
                      sortable: false,
                  },
                  {
                      key: 'unitPrice.amount',
                      sortable: false,
                      formatter: (value) => this.localizedNumber(value),
                      label: this.$t('history.label.UnitPrice'),
                  },
                  {
                      key: 'unitPrice.currencyCode',
                      sortable: false,
                      label: this.$t('history.label.CurrencyCode'),
                  },
              ],
          };
      },

      methods: {},
  };
</script>

<style></style>
